import moment from 'moment';
import React, { useEffect, useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from 'redux/actions/index';
import DropDown from 'components/elements/atoms/DropDown/DropDown';
import FloatingInput from 'components/elements/atoms/FloatingInput/FloatingInput';
import _ from 'lodash';

import './UserExtensionActionsHistory.scss';
import TableColumnFilter from '../TableColumnFilter/TableColumnFilter';

function UserExtensionActionsHistory({ userId, actions }) {
  const [actionsHistory, setActionsHistory] = useState(null);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    fromDate: '',
    toDate: '',
    action: '',
    device: '',
    browser: '',
    version: '',
  });

  async function getData() {
    try {
      setLoading(true);
      const result = await actions.getUserExtensionActionsHistory(userId);
      setActionsHistory(result.actionsHistory || []);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  // Extract unique dropdown values dynamically
  const actionOptions = useMemo(() => {
    if (!actionsHistory) return [];
    return [
      { label: 'All', value: '' },
      { label: 'Installed', value: 'installed' },
      { label: 'Uninstalled', value: 'uninstalled' },
      { label: 'Login', value: 'login' },
      { label: 'Logout', value: 'logout' },
      { label: 'Pinned', value: 'pinned' },
      { label: 'Unpinned', value: 'unpinned' },
    ];
  }, [actionsHistory]);

  const deviceOptions = useMemo(() => {
    if (!actionsHistory) return [];
    const unique = [
      ...new Set(actionsHistory.map((i) => i.device).filter(Boolean)),
    ];
    return [
      { label: 'All', value: '' },
      ...unique.map((d) => ({ label: d, value: d })),
    ];
  }, [actionsHistory]);

  const browserOptions = useMemo(() => {
    if (!actionsHistory) return [];
    const unique = [
      ...new Set(actionsHistory.map((i) => i.browser).filter(Boolean)),
    ];
    return [
      { label: 'All', value: '' },
      ...unique.map((b) => ({ label: b, value: b })),
    ];
  }, [actionsHistory]);

  const versionOptions = useMemo(() => {
    if (!actionsHistory) return [];
    const unique = [
      ...new Set(actionsHistory.map((i) => i.version).filter(Boolean)),
    ];
    return [
      { label: 'All', value: '' },
      ...unique.map((v) => ({ label: v, value: v })),
    ];
  }, [actionsHistory]);

  // Apply filters
  const filteredHistory = useMemo(() => {
    if (!actionsHistory) return [];

    return actionsHistory.filter((item) => {
      const date = moment(item.date).startOf('minute');

      // Date range filter
      if (filters.fromDate) {
        const from = moment(filters.fromDate).startOf('day');
        if (date.isBefore(from)) return false;
      }

      if (filters.toDate) {
        const to = moment(filters.toDate).endOf('day');
        if (date.isAfter(to)) return false;
      }

      // Action filter
      if (filters.action && item.action !== filters.action) return false;

      // Device filter
      if (filters.device && item.device !== filters.device) return false;

      // Browser filter
      if (filters.browser && item.browser !== filters.browser) return false;

      // Version filter
      if (filters.version && item.version !== filters.version) return false;

      return true;
    });
  }, [actionsHistory, filters]);

  const renderFilters = () => (
    <div className="user-extension-actions-history-filters d-flex align-items-center">
      {/* FROM DATE */}
      <div className="date-container">
        <label className="date-label">From Date</label>
        <FloatingInput
          className="mb-0 fromDate"
          type="date"
          value={filters.fromDate}
          onChange={(e) =>
            setFilters((f) => ({ ...f, fromDate: e.target.value }))
          }
          onFocus={(e) => {
            try {
              e.target.showPicker();
            } catch {}
          }}
        />
      </div>

      {/* TO DATE */}
      <div className="date-container">
        <label className="date-label">To Date</label>
        <FloatingInput
          className="mb-0 toDate"
          type="date"
          value={filters.toDate}
          onChange={(e) =>
            setFilters((f) => ({ ...f, toDate: e.target.value }))
          }
          onFocus={(e) => {
            try {
              e.target.showPicker();
            } catch {}
          }}
        />
      </div>

      {/* ACTION FILTER */}
      {/* <DropDown
        className="ml-3"
        labelName="Action"
        value={filters.action}
        onChange={(action) => setFilters((f) => ({ ...f, action }))}
        options={actionOptions}
        isMulti={false}
      /> */}

      {/* DEVICE FILTER */}
      {/* <DropDown
        className="ml-3"
        labelName="Device"
        value={filters.device}
        onChange={(device) => setFilters((f) => ({ ...f, device }))}
        options={deviceOptions}
        isMulti={false}
      /> */}

      {/* BROWSER FILTER */}
      {/* <DropDown
        className="ml-3"
        labelName="Browser"
        value={filters.browser}
        onChange={(browser) => setFilters((f) => ({ ...f, browser }))}
        options={browserOptions}
        isMulti={false}
      /> */}

      {/* VERSION FILTER */}
      {/* <DropDown
        className="ml-3"
        labelName="Version"
        value={filters.version}
        onChange={(version) => setFilters((f) => ({ ...f, version }))}
        options={versionOptions}
        isMulti={false}
      /> */}
    </div>
  );

  if (loading) {
    return (
      <div
        className="fa fa-spin fa-spinner text-primary spinner"
        style={{ fontSize: '20px' }}
      />
    );
  }

  if (!actionsHistory) return null;

  console.log('filters', filters);

  return (
    <div className="user-extension-actions-history">
      {renderFilters()}

      <div className="user-extension-actions-history-table">
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th className="text-center">
                Action
                <TableColumnFilter
                  options={actionOptions}
                  onChange={(action) => setFilters((f) => ({ ...f, action }))}
                  value={filters.action}
                  allowSearch
                />
              </th>
              <th className="text-center">
                Device
                <TableColumnFilter
                  options={deviceOptions}
                  onChange={(device) => setFilters((f) => ({ ...f, device }))}
                  value={filters.device}
                  allowSearch
                />
              </th>
              <th className="text-center">
                Browser
                <TableColumnFilter
                  options={browserOptions}
                  onChange={(browser) => setFilters((f) => ({ ...f, browser }))}
                  value={filters.browser}
                  allowSearch
                />
              </th>
              <th className="text-center">
                Version
                <TableColumnFilter
                  options={versionOptions}
                  onChange={(version) => setFilters((f) => ({ ...f, version }))}
                  value={filters.version}
                  allowSearch
                />
              </th>
            </tr>
          </thead>

          <tbody>
            {filteredHistory.map((item, index) => (
              <tr key={index}>
                <td>{moment(item.date).format('MM/DD/YYYY HH:mm')}</td>

                <td className="text-center">
                  {_.startCase(item.action || '-')}
                </td>

                <td className="text-center">{item.device || '-'}</td>

                <td className="text-center">{item.browser || '-'}</td>

                <td className="text-center">{item.version || '-'}</td>
              </tr>
            ))}

            {filteredHistory.length === 0 && (
              <tr>
                <td colSpan={5} className="text-center pt-4 pb-4">
                  No actions found for selected filters.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {};
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(Actions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UserExtensionActionsHistory);
